const locale = {
    locale: "it_IT",
    yearFormat: "YYYY",
    monthFormat: "MMM",
    dayFormat: "D",
    fieldDateFormat: "dd MMM yyyy",
    monthBeforeYear: true,
    shortWeekDays: ["D", "L", "M", "M", "G", "V", "S"],
    shortMonths: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
};
export default locale;
